import React from 'react';
import { Sliders } from 'lucide-react';
import { startingPoint, images } from '../../data/mock';

const StartingPointSection = () => {
  return (
    <section className="bg-accent-orange text-white">
      <div className="grid lg:grid-cols-2 min-h-[500px]">
        {/* Text Content */}
        <div className="flex flex-col justify-center px-6 lg:px-12 xl:px-20 py-16 lg:py-24">
          <div className="inline-flex items-center gap-2 mb-6">
            <Sliders className="w-5 h-5" />
            <span className="text-sm font-medium uppercase tracking-wider">Fully Customisable</span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium leading-tight mb-6">
            {startingPoint.title}
          </h2>
          <p className="text-lg text-white/90 leading-relaxed mb-6 max-w-lg">
            {startingPoint.content}
          </p>
          <p className="text-base text-white/80 leading-relaxed mb-8 max-w-lg">
            {startingPoint.description}
          </p>

          <div className="p-6 bg-white/10 backdrop-blur-sm max-w-md">
            <p className="text-xl font-medium">"{startingPoint.highlight}"</p>
          </div>
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-2 gap-1">
          <div className="relative">
            <img
              src={images.salonService}
              alt="Salon service"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative">
            <img
              src={images.mobileApp}
              alt="Mobile app"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartingPointSection;
